// TODO [RecipentBadgesCell]: Use this AvatarsCell component, would be easier to scale
import React, { CSSProperties } from 'react';
import { AvatarGroup, AvatarGroupProps, Box } from '@mui/material';
import { CellAlign } from '../cells.type';
import { AvatarCellContext, AvatarCellProvider } from './AvatarsCell.context';
import { Avatar, AvatarProps } from './Avatar';

export interface AvatarsCellProps {
  align?: CellAlign;
  data?: AvatarProps[];
  tooltip?: any;
  avatarGroupProps?: AvatarGroupProps;
  avatarStyle?: CSSProperties;
  small?: boolean;
}

export const AvatarsCell = ({
  align,
  data,
  tooltip,
  avatarGroupProps,
  avatarStyle,
  small = false,
}: AvatarsCellProps) => {
  return (
    <AvatarCellProvider
      align={align}
      data={data}
      tooltip={tooltip}
      avatarGroupProps={avatarGroupProps}
      avatarStyle={avatarStyle}
    >
      <AvatarCellContext.Consumer>
        {({
          align,
          data,
          avatarGroupProps: { sx, ...sxRest },
          avatarStyle,
        }) => {
          return (
            <Box sx={{ display: 'flex' }}>
              <AvatarGroup
                {...sxRest}
                sx={{
                  ...sx,
                  '& .MuiAvatarGroup-avatar': {
                    ...avatarStyle,
                    ':first-of-type': {
                      zIndex: data.length + 1,
                    },
                  },
                }}
              >
                {data
                  .filter(i => i?.group === 'role')
                  ?.map((item, index) => (
                    <Avatar
                      key={`avatar-${index}`}
                      {...item}
                      style={{
                        ...avatarStyle,
                        zIndex: index + 1,
                      }}
                      tooltip={tooltip}
                    />
                  ))}
              </AvatarGroup>
              <AvatarGroup
                {...sxRest}
                sx={{
                  ...sx,
                  '& .MuiAvatarGroup-avatar': {
                    ...avatarStyle,
                    ':first-of-type': {
                      zIndex: data.length + 1,
                    },
                  },
                }}
              >
                {data
                  .filter(i => i?.group !== 'role' || !i?.group)
                  ?.map((item, index) => (
                    <Avatar
                      key={`avatar-${index}`}
                      {...item}
                      style={{
                        ...avatarStyle,
                        zIndex: index + 1,
                      }}
                      tooltip={tooltip}
                    />
                  ))}
              </AvatarGroup>
            </Box>
          );
        }}
      </AvatarCellContext.Consumer>
    </AvatarCellProvider>
  );
};
